import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-open-sharp",
  "use": "icon-open-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-open-sharp\"><title>Open</title><path d=\"M201.37 288l176-176H48v352h352V134.63l-176 176L201.37 288z\" /><path d=\"M320 48v32h89.37l-32 32L400 134.63l32-32V192h32V48H320z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol